import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownContentListCategory = function (props) {
    var group = props.group, itemTemplate = props.itemTemplate, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-category-v2", { ref: ref, group: group ? (typeof group === 'object' ? JSON.stringify(group) : group) : undefined, "item-template": itemTemplate ? (typeof itemTemplate === 'object' ? JSON.stringify(itemTemplate) : itemTemplate) : undefined }, children));
};
export default VeltCommentsSidebarV2FilterDropdownContentListCategory;
